import {
  CREATE_USER_REGISTRATION_FILE_UPLOAD,
  CREATE_USER_REGISTRATION_FILE_UPLOAD_EMPTY,
  CREATE_USER_REGISTRATION_FILE_UPLOAD_SUCCESS,
  CREATE_USER_REGISTRATION_FILE_UPLOAD_ERROR,
} from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UserRegistration = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_USER_REGISTRATION_FILE_UPLOAD:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_USER_REGISTRATION_FILE_UPLOAD_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CREATE_USER_REGISTRATION_FILE_UPLOAD_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_USER_REGISTRATION_FILE_UPLOAD_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UserRegistration;
